import React from 'react';
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 15a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
  fill: "#007E45",
  fillRule: "evenodd"
});
function FilterListActive(_ref) {
  let {
    color = '#335B70',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm11 6.5c0 .17.01.336.028.5H6v-2h8.256c-.166.47-.256.974-.256 1.5z",
    fill: color,
    fillRule: "evenodd"
  }), _ref2));
}
export default FilterListActive;